import { render, staticRenderFns } from "./InstanceItemActions.vue?vue&type=template&id=512bf9a0&scoped=true"
import script from "./InstanceItemActions.vue?vue&type=script&lang=js"
export * from "./InstanceItemActions.vue?vue&type=script&lang=js"
import style0 from "./InstanceItemActions.vue?vue&type=style&index=0&id=512bf9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bf9a0",
  null
  
)

export default component.exports